import { Select, Space } from "antd";
import SearchDate from "./SearchDate";
import SearchUser from "./SearchUser";
import * as Types from "../commons/typeDTO";
import * as TypeUtils from "../commons/typeUtils";

function MemberFilter({
    filterValue,
    onSearch,
    setTableSize,
    request,
    clear,
    onDownload,
    isDownloading,
}: {
    filterValue: TypeUtils.UserSearchType;
    onSearch: (type: string, value: any) => void;
    setTableSize: (size: number) => void;
    request: () => void;
    clear: () => void;
    onDownload?: () => void;
    isDownloading?: boolean;
}) {
    return (
        <Space>
            <SearchDate startDate={filterValue.startDate} endDate={filterValue.endDate} onSearch={onSearch} />

            <span>회원타입:</span>
            <Select
                placeholder="전체"
                options={[
                    { value: "INDIVIDUAL", label: "개인" },
                    { value: "CORPORATE", label: "법인" },
                ]}
                value={filterValue.userType}
                onChange={(e) => {
                    onSearch("userType", e);
                }}
                allowClear
            />

            <span>계정상태:</span>
            <Select
                placeholder="전체"
                options={[
                    { value: "", label: "정상" },
                    { value: "BLOCKED", label: "블랙" },
                    { value: "WITHDRAWN", label: "탈퇴" },
                    { value: "LOCKED", label: "잠김" },
                    { value: "EXPIRED", label: "휴면" },
                ]}
                allowClear
                value={filterValue.userStatus}
                onChange={(e) => {
                    onSearch("userStatus", e);
                }}
            />

            <SearchUser
                setTableSize={setTableSize}
                keyWord={filterValue.keyWord}
                request={request}
                onClear={clear}
                onSearch={onSearch}
                onDownload={onDownload}
                isDownloading={isDownloading}
            />
        </Space>
    );
}

export default MemberFilter;
